<template>
  <div class="form-model-main">
    <div class="add-page-content">
      <div class="title">{{pageTitle}}</div>
      <div class="content">
        <a-form>
          <a-row class="input-row">
            <a-col class="left" :span="12">
              <a-form-item
                :validate-status="isSubmit&&!formData.operateStatusRemark?'error':''"
                :help="isSubmit&&!formData.operateStatusRemark?'请输入跟踪状态':''"
              >
                <div class="name hospital-required">跟踪状态</div>
                <div>
                  <a-input v-model="formData.operateStatusRemark" placeholder="请输入跟踪状态" />
                </div>
              </a-form-item>
            </a-col>
            <a-col class="right" :span="12">
              <a-form-item
                :validate-status="isSubmit&&!formData.operateStatus?'error':''"
                :help="isSubmit&&!formData.operateStatus?'请输入状态标识':''"
              >
                <div class="name hospital-required">状态标识</div>
                <div>
                  <a-input v-model="formData.operateStatus" placeholder="请输入 * 状态标识" />
                </div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row class="input-row">
            <a-col class="left" :span="12">
              <a-form-item
                :validate-status="isSubmit&&!formData.operateRemark?'error':''"
                :help="isSubmit&&!formData.operateRemark?'请输入操作按钮':''"
              >
                <div class="name hospital-required">操作按钮</div>
                <div>
                  <a-input v-model="formData.operateRemark" placeholder="请输入操作按钮" />
                </div>
              </a-form-item>
            </a-col>
            <a-col class="right" :span="12">
              <a-form-item
                :validate-status="isSubmit&&!formData.operateType?'error':''"
                :help="isSubmit&&!formData.operateType?'请输入按钮标识':''"
              >
                <div class="name hospital-required">按钮标识</div>
                <div>
                  <a-input type="email" v-model="formData.operateType" placeholder="请输入按钮标识" />
                </div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row class="input-row">
            <a-col>
              <a-form-item
                :validate-status="isSubmit&&!formData.pid?'error':''"
                :help="isSubmit&&!formData.pid?'请选择操作类别':''"
              >
                <div class="name hospital-required">操作类别</div>
                <a-tree-select
                  style="width: 100%"
                  v-model="formData.pid"
                  :dropdownStyle="{ maxHeight: '300px', overflow: 'auto' }"
                  placeholder="请选择"
                  allowClear
                  treeDefaultExpandAll
                >
                  <a-tree-select-node
                    v-for="(item) in data"
                    :selectable="false"
                    :value="item._data.id+''"
                    :title="item.title"
                    :key="item._data.id+''"
                  >
                    <a-tree-select-node
                      v-for="(cItem) in item.minLst"
                      :value="cItem._data.id+''"
                      :title="cItem.title"
                      :key="cItem._data.id+''"
                    />
                  </a-tree-select-node>
                </a-tree-select>
                <div></div>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <div class="confrim-footer">
          <a-button @click="submitData" type="primary" class="cf-mr10">确定</a-button>
          <a-button @click="closeModel">取消</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: "大类",
    width: "20%",
    scopedSlots: { customRender: "maxType" }
  },
  {
    title: "小类",
    scopedSlots: { customRender: "minType" }
  }
];
export default {
  props: {
    baseData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      data: [],
      columns,
      pageTitle: "添加跟踪状态",
      formData: {
        pid: null
      },
      isSubmit: false,
      bigTypes: []
    };
  },
  components: {},
  mounted() {
    if (this.baseData) {
      this.formData = this.baseData;
      this.pageTitle = "编辑跟踪状态";
    } else {
      this.pageTitle = "添加跟踪状态";
    }
    this.getBigTypes();
  },
  methods: {
    getBigTypes() {
      this.$get("base/baseInfo/findBigClassifyList").then(res => {
        this.bigTypes = res.data.data;
        this.bigTypes.forEach((item, index) => {
          if (index > 1) return;
          // this.data.push({
          //   checked: false,
          //   title: item.operateStatusRemark,
          //   minLst: [],
          //   _data: item
          // });
          let rowData = {
            checked: false,
            title: item.operateStatusRemark,
            minLst: [],
            _data: item
          };
          this.$get(
            "base/baseInfo/findSmallClassifyListByBigClassifyOperateStatus/" +
              item.operateStatus,
            {}
          ).then(res => {
            let ary = res.data.data;
            ary = ary ? ary : [];
            ary.forEach(d => {
              rowData.minLst.push({
                checked: false,
                title: d.operateStatusRemark,
                _data: d
              });
            });
            this.data.push(rowData);
          });
        });
      });
    },
    closeModel() {
      this.$emit("close");
    },
    submitData() {
      this.isSubmit = true;
      this.$nextTick(() => {
        const isPass =
          document.querySelectorAll(".ant-form-explain").length == 0;
        if (isPass) {
          if (this.baseData) {
            // 编辑
            this.$put("base/baseInfo", this.formData, true).then(res => {
              if (res.data.code == 1) {
                this.$message.success("编辑跟踪状态成功");
                this.$emit("close");
              } else {
                this.$message.error(res.data.message);
              }
            });
          } else {
            // 新增
            this.$post("base/baseInfo", this.formData, true).then(res => {
              if (res.data.code == 1) {
                this.$message.success("添加跟踪状态成功");
                this.$emit("close");
              } else {
                this.$message.error(res.data.message);
              }
            });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>